import { eq } from '@tanstack/db'
import { useLiveQuery } from '@tanstack/react-db'
import { useStore } from '@/lib/pocketbase'

export function useTimeEntryAudits(timeEntryId: string | null) {
    const [auditsCollection, usersCollection] = useStore('time_entry_audits', 'users')

    const { isLoading, data: rawAudits = [] } = useLiveQuery(
        q =>
            timeEntryId
                ? q
                      .from({ audit: auditsCollection })
                      .leftJoin({ changedBy: usersCollection }, ({ audit, changedBy }) =>
                          eq(audit.changed_by, changedBy.id)
                      )
                      .where(({ audit }) => eq(audit.time_entry, timeEntryId))
                      .orderBy(({ audit }) => audit.changed_at, 'desc')
                : undefined,
        [timeEntryId]
    )

    const audits = rawAudits.map(row => ({
        ...row.audit,
        changedByName: row.changedBy?.name ?? 'Unknown',
    }))

    return { audits, isLoading }
}
